import OldVines from "../../images/hero-old-vine.jpg";
import { Box } from "../../components/styled-system/Box";
import styled from "styled-components";
import { Form } from "react-bootstrap";
import { useState, useEffect } from "react";
import "./MainPage.scss";
import { useNavigate } from "react-router-dom";
import { Paths } from "../../paths";
import { SearchTips } from "../../components/search-tips/SearchTips";
import { NavigationLink } from "../../components/styled-system/NavigationLink";
import { getDatabaseInfo } from "../../api/old-vine-registry-api";

const PicturePanel = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-image: url(${OldVines});
  background-position: center;
  background-repeat: no-repeat;
`;

const SearchPanel = styled.div`
  max-width: 788px;
  width: 100vw;
  padding-bottom: 50px;
  margin: 0 10px;
  background: white;
`;

function useLastUpdated(): string {
  const [lastUpdated, setLastUpdated] = useState("");
  useEffect(() => {
    getDatabaseInfo().then((databaseInfo) => setLastUpdated(databaseInfo));
  }, []);
  return lastUpdated;
}

export const MainPage = () => {
  const databaseInfo = useLastUpdated();
  const numberOfRecords = databaseInfo && databaseInfo["numberOfRecords"];
  const totalHectares = databaseInfo && databaseInfo["totalHectares"];
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState("");

  return (
    <Box display="flex" flexDirection="column" paddingBottom="50px">
      <PicturePanel className="picture-panel">
        <SearchPanel className="search-panel">
          <Box mt="50px" className="cinzel-heading" mb="1.6rem">
            The Old Vine Registry
          </Box>
          <Box className="description-text-center">
            Welcome to the world’s first crowd-sourced global database of living{" "}
            <NavigationLink to={Paths.oldVinesInfo}>
              <span className="description-text-link">
                historic vineyard sites
              </span>
            </NavigationLink>
            . We seek to create the world’s most authoritative record of these
            vineyards in the hopes that through greater awareness and attention
            these vineyards and the wines they produce will survive and thrive.{" "}
            <NavigationLink to={Paths.about}>
              <span className="description-text-link">Learn more</span>.
            </NavigationLink>
          </Box>
          <Box display="flex" mt="20px">
            <Form.Control
              placeholder="Enter a vineyard name, winery name, region, grape variety, etc"
              onChange={(e) => setSearchText(e.target.value)}
              onKeyUp={(e) => {
                if (e.key === "Enter" && searchText) {
                  navigate(`${Paths.vineyards}?search=${searchText}`);
                }
              }}
              className="input-text"
            />
            <button
              className="button u-ml-small"
              disabled={!searchText}
              onClick={() =>
                navigate(`${Paths.vineyards}?search=${searchText}`)
              }
            >
              Search
            </button>
          </Box>
          {databaseInfo && <Box className="description-text-center">
            <br/>
            The database contains <b>{numberOfRecords}</b> vineyards and a total of <b>{totalHectares}</b> hectares
          </Box>}
        </SearchPanel>
      </PicturePanel>

      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        padding="0 30px"
        mt="4rem"
      >
        <SearchTips
          className="u-mt-large"
          searchCountry={(country) =>
            navigate(`${Paths.vineyards}?country=${country}`)
          }
          searchAgeRange={(ageRange) =>
            navigate(`${Paths.vineyards}?age=${encodeURIComponent(ageRange)}`)
          }
        />
      </Box>
    </Box>
  );
};
